import { OrderTransportingOrderAvailableConsumersItem } from "../../../../../../common/services/order/transporting-order/available-consumers/order-transporting-order-available-consumers";
import OrderDetailsForwardingAvailableConsumer from "./order-details-forwarding-available-consumer";
import OrderDetailsForwardingAvailableConsumerSelectOption from "./order-details-forwarding-available-consumer-select-option";

const createAvailableConsumer = (
  responseTaxiAvailableConsumers: OrderTransportingOrderAvailableConsumersItem,
): OrderDetailsForwardingAvailableConsumer => {
  return {
    id: responseTaxiAvailableConsumers.id,
    name: responseTaxiAvailableConsumers.name,
  };
};

const createSelectOption = (
  taxiAvailableConsumers: OrderDetailsForwardingAvailableConsumer,
): OrderDetailsForwardingAvailableConsumerSelectOption => {
  return {
    label: taxiAvailableConsumers.name,
    value: taxiAvailableConsumers,
  };
};

const createSelectOptions = (
  responseTaxiAvailableConsumers: OrderTransportingOrderAvailableConsumersItem[],
): OrderDetailsForwardingAvailableConsumerSelectOption[] => {
  const taxiCorporations = responseTaxiAvailableConsumers.map(
    createAvailableConsumer,
  );

  return taxiCorporations.map(createSelectOption);
};

const orderDetailsForwardingAvailableConsumerFactory = {
  createSelectOptions,
};

export default orderDetailsForwardingAvailableConsumerFactory;
